import type { ESN, PageableContent, UUID } from '@cobliteam/common-types';

export const CHECKLIST_VERSION = 2;

export enum ChecklistFieldType {
  CHECK = 'CHECK',
  TEXT = 'TEXT',
  MULTI_SELECT = 'MULTI_SELECT',
  SINGLE_SELECT = 'SINGLE_SELECT',
}

export interface ChecklistCheckboxContent {
  checked: boolean | null;
}

export interface ChecklistTextContent {
  value: string | null;
}

export interface ChecklistSelectOptionContent {
  label: string;
  checked: boolean | null;
}

export interface ChecklistSelectContent {
  options: ChecklistSelectOptionContent[];
}

export type ChecklistFieldContent =
  | ChecklistCheckboxContent
  | ChecklistTextContent
  | ChecklistSelectContent;

export interface TemplateChecklistField {
  type: ChecklistFieldType;
  required: boolean;
  title: string;
  content: ChecklistFieldContent;
}

export interface ChecklistField extends TemplateChecklistField {
  id: UUID;
}

export interface ChecklistVehicle {
  deviceId: ESN;
  licensePlate?: string;
  brand?: string;
  model?: string;
}

export interface ChecklistContext {
  appVersion: string;
  vehicle?: ChecklistVehicle;
}

export interface UpdatedChecklist {
  version: number;
  name: string;
  fields: TemplateChecklistField[];
}

export interface NewChecklist extends UpdatedChecklist {
  template: boolean;
}

export type TemplateChecklist = NewChecklist | UpdatedChecklist;

export interface Checklist extends NewChecklist {
  id: UUID;
  createdAt: number;
  createdBy: string;
  fields: ChecklistField[];
  templateId: UUID | null;
  context: ChecklistContext | null;
}

export interface ChecklistsNames {
  names: string[];
}

export interface ChecklistsPage {
  page: PageableContent<Checklist>;
}
